<template>
    <div>
      <input type="button" v-on:click="getAccount" value="Get Accounts"/>
      <table>
        <thead>
          <th>ID</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Created</th>
        </thead>
        <tbody>
        <template v-for="account in accounts">
          <tr>
            <td>{{account.id}}</td>
            <td>{{account.firstName}}</td>
            <td>{{account.lastName}}</td>
            <td>{{account.created}}</td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        accounts: []
      }
    },
    methods: {
      getAccount () {
        this.$http.get('/api/account').then((response) => {
          console.info(response.data)
          if (response.data.success) {
            this.accounts = response.data.result
          } else {
            alert(response.data.errmsg)
          }
        }, (response) => {
          // 响应错误回调
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/about/component/http.vue